import React from "react";

export const UnreadDot = ({ n, testId }) => (n > 0 ? (
  <span className="relative inline-flex w-2.5 h-2.5" data-testid={testId} aria-label={`${n} messaggi non letti`} title={`${n} messaggi non letti`}>
    <span className="absolute inline-flex w-full h-full rounded-full bg-red-500 opacity-60 animate-ping"/>
    <span className="relative inline-flex w-2.5 h-2.5 rounded-full bg-red-600 ring-2 ring-white"/>
  </span>
) : null);
